<template>
  <Layout>
    <Toasts
        :show-progress="true"
        :rtl="true"
        :max-messages="20"
        :time-out="3000"
        :closeable="false"
        :solid="true"
    ></Toasts>
    <PageHeader :items="items" :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length"></div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <b-button
                    v-if="user_permissions?user_permissions.add_consultaion:false"
                    v-b-modal.category-modal
                    variant="primary"
                    ><i class="fa fa-plus"></i> New Category
                  </b-button>
                  <!--ADDING NEW SERVICE MODAL-->
                  <b-modal
                    id="category-modal"
                    centered
                    ref="modal"
                    hide-footer
                    title="Add New Service Categorys"
                    @hidden="resetAddModal"> 
                    <div class="form-group mb-3" v-if="branch_id == 0">
                      <label>Select Branch</label>
                      <select                       
                        v-model="data.branch_id"
                        class="form-control"                      
                      >
                        <option value="All">All</option>
                        <option  v-for="item in GetBranch" :value="item.Id" :key="item.Id">{{item.branchName}}</option>
                      </select>
                      <div class="text-danger" v-if="branchError">
                        <em>{{ branchError }}</em>
                      </div>
                    </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="service-name">Categroy Name:</label>
                        <input
                          id="service-name"
                          v-model="data.categoryName"
                          class="form-control"
                          required
                          type="text"
                          @keyup="checkName"
                          placeholder="E.g 	Malaria test"/>
                        <div class="text-danger" v-if="nameError">
                          <em>{{ nameError }}</em>
                        </div>
                      </div>
                       
                 
                   
                    <div class="modal-footer">
                      <button
                        class="btn btn-secondary"
                        @click="$bvModal.hide('category-modal')"
                        type="button"
                      >
                        Close
                      </button>
                      <button
                        v-if="existingCategory.length"
                        class="btn btn-info"
                        disabled
                        title="This category already exists"
                        type="button">
                        <i class="fa fa-ban"></i> Save Category
                      </button>
                      <button
                        v-else
                        class="btn btn-primary"
                        type="button"
                        @click="saveCategory('category-modal')">
                        Save Category
                        <b-spinner
                            v-if="ServiceStatus"
                            variant="light" small
                            role="status"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!--EDITING SERVICE MODAL-->
                  <b-modal
                    id="edit-modal"
                    centered
                    ref="modal"
                    hide-footer
                    :title="editData.categoryName"
                    @hidden="resetEditModal"
                  >
                    <form ref="form" @submit.stop.prevent="saveChanges">
                    <div class="form-group mb-3" v-if="branch_id == 0">
                      <label>Select Branch</label>
                      <select                       
                        v-model="editData.branch_id"
                        class="form-control"                      
                      >
                        <option value="All">All</option>
                        <option  v-for="item in GetBranch" :value="item.Id" :key="item.Id">{{item.branchName}}</option>
                      </select>
                      <div class="text-danger" v-if="branchError">
                        <em>{{ branchError }}</em>
                      </div>
                    </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="name">Category Name:</label>
                        <input
                          id="name"
                          v-model="editData.categoryName"
                          @keyup="checkName"
                          class="form-control"
                          type="text"
                        />
                        <div class="text-danger" v-if="nameError">
                          <em>{{ nameError }}</em>
                        </div>
                      </div>
                
                    </form>
                    <div class="modal-footer">
                      <button
                        class="btn btn-secondary"
                        @click="$bvModal.hide('edit-modal')"
                        type="button"
                      >
                        Close
                      </button>
                      <button
                        v-if="existingCategory.length"
                        class="btn btn-info"
                        disabled
                        title="This Category already exists"
                        type="button"
                      >
                        <i class="fa fa-ban"></i> Save Category
                      </button>
                      <button
                        v-else
                        class="btn btn-primary"
                        type="button"
                        @click="handleEditModal"
                      >
                        Save Category
                      </button>
                    </div>
                  </b-modal>

                  <!--                  DELETING SERVICE MODAL-->
                  <b-modal
                    id="delete-modal"
                    header-bg-variant="warning"
                    header-text-variant="light"
                    ref="modal"
                    size="sm"
                    centered
                    title="Confirmation Alert"
                    @hidden="resetDeleteModal"
                    @ok="confirmDelete"
                  >
                    <div class="d-block text-center">
                      <h5>
                        Are you sure you want to delete
                        <code>{{ this.deleteData.categoryName }}</code
                        >? <br />
                        Click <code>OK</code> to continue
                      </h5>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="this.labCategories"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(action)="data">
                  <!-- Edit Modal -->
                  <b-button
                    v-if="user_permissions?user_permissions.edit_consultaion:false"
                    v-b-modal.edit-modal
                    size="sm"
                    variant="primary"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit
                  </b-button>
                  <b-button
                    v-else
                    disabled
                    v-b-modal.edit-modal
                    size="sm"
                    variant="primary"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit
                  </b-button>
                  |
                  <!-- Delete Modal -->
                  <b-button
                    v-if="user_permissions?user_permissions.delete_consultaion:false"
                    v-b-modal.delete-modal
                    size="sm"
                    variant="danger"
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete
                  </b-button>
                  <b-button
                    v-else
                    disabled
                    v-b-modal.delete-modal
                    size="sm"
                    variant="danger"
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete
                  </b-button>
                </template>
              </b-table>
              <h3 v-if="!this.labCategories" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import { ModelListSelect } from "vue-search-select";
import {mapGetters, mapActions, mapState} from "vuex";

export default {
  page: {
    title: "Lab service category",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    // ModelListSelect
  },

  data() {
    return {
      title: "Lab service Categories",
      items: [
        {
          text: "Advanced Settings",
          href: "#",
        },
        {
          text: "Lab service Categories",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
       
        {
          key: "categoryName",
          sortable: true,
          label: "CATEGORY NAME",
        },
        
      
        {
          key: "dateCreated",
          sortable: true,
          label: "DATE & TIME",
        },
        {
          key: "action",
          sortable: false,
          label: "ACTION",
        },
      ],
      data: {
        categoryName: "",
        branch_id: "All",
      },
      existingCategory: [],
      nameError: "",
      priceError: "",
      costError: "",
      branchError:"",
      model_id:"",
      editData: {
        id: "",
        categoryName: "",
        branch_id: "",
       
      },
      deleteData: {
        id: "",
        categoryName: "",
      },
    };
  },

  computed: {
    ...mapGetters("services", ["labCategories","ServiceStatus"]),
    ...mapGetters("auth", ["user_permissions","branch_id"]),
    ...mapGetters("branch", ["GetBranch"]),
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),

    rows() {
      return this.labCategories ? this.labCategories.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.labCategories ? this.labCategories.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }},
  },
  methods: {
    ...mapActions({
      FetchLabCategories: "services/fetchLabCategories",
      SubmitService: "services/saveLabCategory",
      SubmitUpdates: "services/updateLabCategory",
      DeleteService: "services/deleteLabCategory",
      FetchBranch: "branch/fetchBranch",
    }),

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering Separator
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    thousandSeparator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    checkName() {
      //when creating a new one
      if (this.data.categoryName !== "") {
        this.existingCategory = this.labCategories.filter((service) => {
          return service.categoryName.toUpperCase() === this.data.categoryName.toUpperCase();
        });
        if (this.existingCategory.length) {
          this.nameError = this.data.categoryName + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingCategory = [];
      }
    },


    saveCategory(modelId) {
      this.model_id = modelId;
      //Now validate for required fields
      if (this.data.categoryName === "") {
        this.nameError = "Category name is required";
        return;
      } else {
        this.nameError = "";
      }
  
      
      // Push the data submitted to the endpoint
      this.SubmitService(this.data);
    },

    //Now reset the add modal
    resetAddModal() {
      this.data.categoryName = "";
      this.nameError = "";
      this.existingCategory = [];
    },

    showEditModal(data) {
      this.editData.id = data.item.id;
      this.editData.branch_id = data.item.branch_id;
      this.editData.categoryName = data.item.categoryName;
     
    },

    handleEditModal(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.saveChanges();
    },

    saveChanges() {
      //Now validate for required fields
      if (this.editData.categoryName == "") {
        this.nameError = "Category name is required";
        return;
      } else {
        this.nameError = "";
      }
  
      // Push the data submitted to the endpoint
      this.SubmitUpdates(this.editData);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("edit-modal");
      });
    },

    resetEditModal() {
      this.editData.categoryName = "";
      this.nameError = "";
      this.editData.id = "";
    },
    showDeleteModal(data) {
      this.deleteData.categoryName = data.item.categoryName;
      this.deleteData.id = data.item.id;
    },
    confirmDelete() {
      // Push the data submitted to the endpoint
      this.DeleteService(this.deleteData);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("delete-modal");
      });
    },
    resetDeleteModal() {
      this.deleteData.id = "";
      this.deleteData.categoryName = "";
    },

    // CLOSE MODEL
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
  },

  created() {
    this.FetchLabCategories();
    this.FetchBranch();
  },
};
</script>

<style lang="css" scoped></style>
